import debounce from 'lodash-es/debounce';
import $ from 'jquery';

const IS_EDITOR = !! window.adminpage;

const SWIPER_SETTINGS = {
  loop: false,
  navigation: {
    prevEl: '.js-plara__prev-btn',
    nextEl: '.js-plara__next-btn',
  },
  pagination: {
    el: '.js-plara__pagination',
    type: 'progressbar',
    clickable: true,
    progressbarFillClass: 'plara__progress',
    bulletClass: 'plara__pagination__bullet',
    bulletActiveClass: 'plara__pagination__bullet-active',
  },
  slidesPerView: 2.2,
  slidesPerGroup: 2,
  spaceBetween: 25,
  preloadImages: false,
  allowTouchMove: !IS_EDITOR,
  freeMode: {
    enabled: true,
    momentum: true,
    momentumRatio: 2,
  },
  breakpoints: {
    450: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    700: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    900: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
    1200: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    },
  },
};

const EXPLANATION_SWIPER_SETTINGS = {
  ...SWIPER_SETTINGS,

  slidesPerView: 1.1,
  slidesPerGroup: 1.1,
  breakpoints: {
    450: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    1200: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
  },
};

const PLARA_THEME_SWIPER_SETTINGS = {
  ...SWIPER_SETTINGS,

  spaceBetween: 20,
  slidesPerView: 1.1,
  slidesPerGroup: 1.1,
  breakpoints: {
    450: {
      slidesPerView: 1.5,
      slidesPerGroup: 1.5,
    },
    700: {
      slidesPerView: 1.75,
      slidesPerGroup: 1.75,
    },
    900: {
      slidesPerView: 2.25,
      slidesPerGroup: 2.25,
    },
    1100: {
      slidesPerView: 2.75,
      slidesPerGroup: 2.75,
    },
    1250: {
      slidesPerView: 3.25,
      slidesPerGroup: 3.25,
    },
    1400: {
      slidesPerView: 3.25,
      slidesPerGroup: 3.25,
    },
  },
};

function findSlidePerViewAmountForCurrentWindowWidth(swiperSettings, windowWidth) {
  const breakpoints = swiperSettings.breakpoints;

  const keys = Object.keys(breakpoints);
  for (let key of keys.reverse()) {
    if (windowWidth > key) {
      return breakpoints[key].slidesPerView;
    }
  }

  // if breakpoint is not found, return default settings
  return swiperSettings.slidesPerView;
}

export function hidePaginationIfNeeded(container, settings) {
  const windowWidth = window.outerWidth;
  const slidePerViewForCurrentWindowWidth
      = findSlidePerViewAmountForCurrentWindowWidth(settings || SWIPER_SETTINGS, windowWidth);

  const slideAmount = container.querySelectorAll('.js-swiper-slide').length;
  const pagination = container.querySelector(".js-plara__pagination");

  if (slideAmount <= slidePerViewForCurrentWindowWidth) {
    pagination.style.display = 'none';
  } else {
    pagination.style.display = 'block';
  }
}

function removeLastWord(str) {
  var lastIndex = str.lastIndexOf(' ');
  str = str.substring(0, lastIndex);
  return str;
}

function replaceLastWordWithThreeDots(str) {
  str = removeLastWord(str);
  str += '...';
  return str;
}

export function calculateIngressLengths(container) {
  $(container).find('.js-plara-template__content-container').each(function () {
    const $plaraContent = $(this);
    const $plaraTitle = $plaraContent.find(".js-plara-template__heading");
    const $plaraIngress = $plaraContent.find(".js-plara-template__ingress");

    if (typeof($plaraIngress) !== 'undefined' && $plaraIngress.length > 0) {
      const plaraIngressContent = $plaraIngress.attr("data-original");
      const words = plaraIngressContent.split(" ");
      $plaraIngress.html('');

      const plaraContentHeight = $plaraContent.height();
      for (let i = 0; i < words.length; i++) {
        const titleAndIngressHeight = $plaraIngress.outerHeight(true) + $plaraTitle.outerHeight(true) + 10;

        if (titleAndIngressHeight > plaraContentHeight) {
          //last word was too much, remove last one
          let plaraContent = removeLastWord($plaraIngress.text());
          plaraContent = replaceLastWordWithThreeDots(plaraContent);

          $plaraIngress.text(plaraContent);
          break;
        }

        $plaraIngress.text($plaraIngress.text() + ' ' + words[i]);
      }
    }
  });
}

export default async function init(container) {
  const { default: Swiper, Navigation, Pagination, A11y, FreeMode } = await import(
    /* webpackChunkName: "components/swiper" */
    /* webpackExports: ["default", "Navigation", "Pagination", "A11y", "FreeMode"] */
    'swiper'
  )

  if (container.classList.contains('swiper-container-initialized')) {
    return;
  }

  const isExplanationBlock = container.classList.contains('js-explanation-swiper');
  const isPlaraThemePlaraBlock = container.classList.contains('js-plara-focus_area-swiper');

  const settings = {
    ...(isExplanationBlock ? EXPLANATION_SWIPER_SETTINGS : isPlaraThemePlaraBlock ? PLARA_THEME_SWIPER_SETTINGS : SWIPER_SETTINGS),
    ...JSON.parse(container.dataset.swiper || '{}'),
  };

  function onUpdate() {
    calculateIngressLengths(container);
    hidePaginationIfNeeded(container, settings);
  }

  window.addEventListener('resize', debounce(() => onUpdate(), 500));

  const swiper = new Swiper(container, {
    modules: [Navigation, Pagination, A11y, FreeMode],
    ...settings,
    on: {
      init: () => onUpdate(),
    },
  });

  return swiper;
}
